// extracted by mini-css-extract-plugin
module.exports = {"ns-email-simple":"NsEmailSimple_ns-email-simple_ztvjB"};